import { TomSelectedElement } from './types/html-elements';

function w8ApplyFacetEnhancements() {
  // Робимо неактивним селект моделі, якщо не вибрано марку.
  // На архіві марки (lot_cat) марка задана самою таксономією, а не фасетом,
  // тому там модель має бути активною одразу — інакше мульти-вибір моделей
  // у режимі Line був би заблокований (W8-3051).
  document
    .querySelector('.facetwp-facet-model .fs-wrap')
    ?.classList.add('disabled');
  const makeChosen =
    typeof FWP.facets['make'] !== 'undefined' && FWP.facets['make'].length;
  if (makeChosen || window.theme.page.is_lot_cat) {
    document
      .querySelector('.facetwp-facet-model .fs-wrap')
      ?.classList.remove('disabled');
  }

  const facet_selections = document.querySelector('.facetwp-selections');
  facet_selections?.classList.remove('pointer-events-none');

  const facets = document.querySelectorAll('.facetwp-facet');
  for (let i = 0; i < facets.length; i++) {
    const facet = facets[i];
    const facet_name = facet.getAttribute('data-name');
    const facet_type = facet.getAttribute('data-type');
    if (!facet_name) continue;

    const facet_label = FWP.settings.labels[facet_name];

    const blacklist = Array.from(
      new Set(
        [
          'reset',
          'result_counts',
          'future_lot',
          'sorting',
          'sorting_ho',
          // "buy_it_now",
          'location',
          'pagination',
          'load_more',
        ].concat(window.blackListFwp || []),
      ),
    );

    if (facet_name == 'location') {
      facet.classList.add(
        'grid',
        'md:grid-cols-2',
        'lg:grid-cols-3',
        '2xl:grid-cols-5',
        'gap-5',
        'md:gap-4',
      );
      Array.from(facet.children).forEach((el, index) => {
        if (index == 0) {
          el.classList.add('hidden');
          return;
        }
        const classes = ['btn-shadow-lg'];
        if (!el.classList.contains('checked')) {
          classes.push('border-raven-lighter', 'font-normal');
        }
        el.classList.add(...classes);
      });
    }

    if (!blacklist.includes(facet_name) && !facet.closest('.facet-wrap')) {
      const classes = ['facet-wrap', 'mt-5', 'facet-wrap-' + facet_type];
      const wrapper = document.createElement('div');
      wrapper.className = classes.join(' ');
      wrapper.setAttribute('data-for', facet_name);
      const label = document.createElement('span');
      label.className = 'facet-label';
      // if (window.catalogTemplate === "lots-3") label.classList.add('!mb-[14px]', 'block');
      label.textContent = facet_label;
      wrapper.appendChild(label);
      facet.parentNode!.insertBefore(wrapper, facet);
      wrapper.appendChild(facet);
    }

    if (facet_type !== 'pager' && facet_type !== 'sort') {
      if (!facet.closest('.facet-wrap')) {
        // Do nothing
      } else if (
        FWP.settings.num_choices[facet_name] !== undefined &&
        FWP.settings.num_choices[facet_name] <= 0
      ) {
        const wrapper = document.querySelector(
          '.facet-wrap[data-for="' + facet_name + '"]',
        ) as HTMLElement | null;
        if (wrapper) {
          wrapper.style.display = 'none';
        }
      }
    }
  }

  Object.entries(FWP.settings.num_choices).forEach(([key, val]) => {
    const wrapper = document
      .querySelector<HTMLElement>(`.facetwp-facet-${key}`)
      ?.closest<HTMLElement>('.facet-wrap');

    if (!wrapper) return;

    wrapper.style.display =
      val === 0 ? 'none' : key === 'buy_it_now' ? 'flex' : 'block';
  });

  if (window.theme.page.is_lot_cat) {
    document.querySelector('.facetwp-reset')?.addEventListener('click', (e) => {
      e.preventDefault();
      // Reset on a make/model archive returns to the main catalog, but it must
      // keep the current display mode (Line/Card) — otherwise Line silently
      // flips to Card on reset (W8-3051). The single-facet "x" already keeps it.
      const view = new URLSearchParams(window.location.search).get('view');
      const base = window.theme.pages.catalog.url;
      window.location.href = view
        ? `${base}${base.includes('?') ? '&' : '?'}view=${encodeURIComponent(view)}`
        : base;
    });
  }

  const query = FWP.buildQueryString() ? '?' + FWP.buildQueryString() : '';
  const selectFilterMake = document.getElementById('filter-make') as
    | HTMLSelectElement
    | TomSelectedElement
    | null;
  const selectFilterModel = document.getElementById('filter-model') as
    | HTMLSelectElement
    | TomSelectedElement
    | null;
  const selections = document.querySelectorAll(
    '.eridanfacet-selections a',
  ) as NodeListOf<HTMLAnchorElement>;

  if (selectFilterMake) {
    selectFilterMake.dataset.link = selectFilterMake.dataset.link + query;

    selections.forEach((el) => (el.href = el.dataset.linkDefault + query));

    for (const option of selectFilterMake.options) {
      option.dataset.link = option.dataset.linkDefault + query;
    }

    if (selectFilterModel) {
      selectFilterModel.dataset.link = selectFilterModel.dataset.link + query;
      for (const option of selectFilterModel.options) {
        option.dataset.link = option.dataset.linkDefault + query;
      }
    }
    if ('tomselect' in selectFilterMake) {
      selectFilterMake.tomselect.sync();
    }
    if (selectFilterModel && 'tomselect' in selectFilterModel) {
      selectFilterModel.tomselect.sync();
    }
  }

  // Змінювати кількість лотів під час фільтрації і робити disabled там де 0
  // В POLESTAR попали авто MAZDA 2
}

document.addEventListener('facetwp-loaded', w8ApplyFacetEnhancements);

// Scroll back to the top of the results ONLY when the user paginates. The old
// code scrolled on every `facetwp-loaded`, so picking a value near the bottom
// of any dropdown (Color, Damage, …) yanked the page to the top (W8-3051).
// Numbered pagination links carry `.facetwp-page`; "load more" uses a different
// class and facet selection isn't a click on these links, so neither scrolls.
let scrollToResultsAfterLoad = false;
document.addEventListener(
  'click',
  (e) => {
    if ((e.target as Element | null)?.closest?.('.facetwp-page')) {
      scrollToResultsAfterLoad = true;
    }
  },
  true,
);
document.addEventListener('facetwp-loaded', () => {
  if (!scrollToResultsAfterLoad) return;
  scrollToResultsAfterLoad = false;
  const content = document.getElementById('content');
  if (content) {
    window.scrollTo({ top: content.offsetTop, behavior: 'smooth' });
  }
});

// Race guard. Vite builds this file as a deferred ES module, so it can
// register the listener above AFTER FacetWP has already fired its
// initial `facetwp-loaded` (FacetWP prefills facets from embedded JSON
// on DOMContentLoaded). When that happens NONE of the enhancements run
// on first paint — facet labels are missing, radios stay unstyled, and
// the location "any" option ("Всякакви" on the CZ slave, etc.) isn't
// hidden. If FacetWP reports it already loaded, run once immediately so
// the first render matches every subsequent refresh.
if (typeof FWP !== 'undefined' && FWP.loaded) {
  w8ApplyFacetEnhancements();
}

document.addEventListener('facetwp-refresh', function () {
  if (FWP.facets['make'] && FWP.facets['make'].length == 0) {
    FWP.facets['model'] = []; // Reset this facet
  }
  document
    .querySelector('.facetwp-selections')
    ?.classList.add('pointer-events-none');

  if (
    (FWP.active_facet === null && FWP.loaded) ||
    (FWP.active_facet &&
      fUtil(FWP.active_facet.nodes[0]).attr('data-name') != 'load_more')
  ) {
    const container =
      document.querySelector('.facetwp-template') ??
      document.querySelector('.facetwp-template ul');
    const skeleton = document
      .getElementById('lot-skeleton-wrap')
      ?.querySelector('li');

    container
      ?.querySelectorAll('li[data-lot]:not(.form-swat)')
      ?.forEach((element) => {
        // Create a clone of the skeleton element
        const skeletonClone = skeleton?.cloneNode(true) as
          | HTMLElement
          | undefined;
        if (skeletonClone) {
          skeletonClone.style.height = element.clientHeight + 'px';
          // Replace the current element with the clone
          container.replaceChild(skeletonClone, element);
        }
      });
  }

  if (window.catalogTemplate === 'lots-3') {
    // Check if any filters are applied
    const hasActiveFilters = Object.keys(FWP.facets).some(
      (key) => FWP.facets[key] && FWP.facets[key].length > 0,
    );

    const sidebar = document.getElementById('sidebar');

    // Configuration: [element, classesToAddWhenFiltered, classesToRemoveWhenFiltered]
    const layoutConfig: Array<[HTMLElement | null, string[], string[]]> = [
      [
        document.getElementById('sidebar--filter-wrapper'),
        [
          'lg:h-[calc(100vh-(var(--header-height)+40px))]',
          'lg:sticky',
          'lg:top-[calc(var(--header-height)+20px)]',
          'lg:bg-[#FCFEFE]',
          'lg:border-2',
          'lg:border-mist-dark',
          'lg:shadow-theme-grey-main',
          'lg:rounded-[32px]',
        ],
        ['lg:h-auto', 'lg:overflow-visible'],
      ],
      [
        document.getElementById('sidebar--filter-first-child'),
        ['lg:border-none', 'lg:bg-transparent'],
        [
          'lg:bg-[#FCFEFE]',
          'lg:border-2',
          'lg:shadow-theme-grey-main',
          'lg:rounded-[32px]',
          'lg:overflow-visible',
        ],
      ],
      [
        document.getElementById('content')?.parentElement ?? null,
        ['lg:flex', 'lg:flex-row'],
        ['lg:flex-col'],
      ],
      [
        document.getElementById('filter'),
        [],
        [
          'md:grid-cols-2',
          'lg:grid-cols-3',
          'xl:grid-cols-4',
          '2xl:grid-cols-5',
        ],
      ],
      [sidebar, ['w-[300px]'], ['lg:w-full', 'w-full', 'lg:mb-3']],
      [document.getElementById('filter-header'), [], ['lg:flex-row']],
      [
        document.getElementById('filter-header-selections'),
        [],
        ['lg:flex-row', 'lg:items-center'],
      ],
      [
        document.getElementById('filter-header-buy-it-now'),
        [],
        ['lg:flex-row', 'lg:items-center'],
      ],
      [
        document.getElementById('filter-bottom'),
        [],
        [
          'md:items-center',
          'md:grid',
          'md:grid-cols-2',
          'lg:grid-cols-3',
          'xl:grid-cols-4',
          '2xl:grid-cols-5',
          'lg:gap-y-6',
          'lg:gap-x-8',
          'lg:mt-6',
        ],
      ],
      [
        window.location.search.includes('view=list')
          ? null
          : (document.querySelector('.facetwp-template') ??
            document.querySelector('.facetwp-template ul')),
        ['lg:grid-cols-2', '2xl:grid-cols-3'],
        ['lg:grid-cols-3', '2xl:grid-cols-4'],
      ],
    ];

    layoutConfig.forEach(([element, addClasses, removeClasses]) => {
      if (!element) return;

      if (hasActiveFilters) {
        if (removeClasses.length) element.classList.remove(...removeClasses);
        if (addClasses.length) element.classList.add(...addClasses);
      } else {
        if (addClasses.length) element.classList.remove(...addClasses);
        if (removeClasses.length) element.classList.add(...removeClasses);
      }
    });
    if (sidebar && sidebar.floatSidebarInstance) {
      if (hasActiveFilters) {
        sidebar.floatSidebarInstance.setScrollSidebar();
        sidebar.floatSidebarInstance.forceUpdate();
      } else {
        sidebar.floatSidebarInstance.destroy();
      }
    }

    // Toggle facet-label margin
    document.querySelectorAll('.facet-label').forEach((label) => {
      if (label instanceof HTMLElement) {
        if (hasActiveFilters) {
          label.classList.remove('!mb-[14px]', 'block');
        } else {
          label.classList.add('!mb-[14px]', 'block');
        }
      }
    });
  }

  // if (facet_type && ['fselect', 'range_list'].includes(facet_type)) {
  //   const fsLabel = wrapper;
  //   const hasSelection = FWP.facets[facet_name] && FWP.facets[facet_name].length > 0;
  //   console.log(hasSelection);

  //   if (fsLabel) {
  //     if (hasSelection) {
  //       fsLabel.classList.remove('non-selected');
  //     } else {
  //       fsLabel.classList.add('non-selected');
  //     }
  //   }
  // }
});

document.addEventListener('DOMContentLoaded', function () {
  if ('undefined' !== typeof FWP && 'undefined' !== typeof FWP.hooks) {
    // @ts-expect-error - ts doesn't know about addFilter
    FWP.hooks.addFilter('facetwp/set_options/fselect', function (opts) {
      // @ts-expect-error - ts doesn't know about optionFormatter
      opts.optionFormatter = function (label, node) {
        const counter = node.getAttribute('data-counter');
        return counter
          ? `<span class="truncate">${label}</span><span class="facetwp-counter !ml-auto">(${counter})</span>`
          : label;
      };
      return opts;
    });
  }

  const selections = document.querySelector('.eridanfacet-selections');
  selections?.addEventListener('click', () => {
    selections?.classList.add('pointer-events-none');
  });

  const bindSelectRedirect = (id: string) => {
    const select = document.getElementById(id) as TomSelectedElement | null;
    if (!select || !('tomselect' in select)) {
      return;
    }

    select.tomselect.on('change', (value: string) => {
      let url: string | undefined;
      if (value === '') {
        url = select.dataset.link;
      } else {
        const safeValue = CSS.escape(value);
        const option = document.querySelector(
          `#${id} [value="${safeValue}"]`,
        ) as HTMLOptionElement | null;
        url = option?.dataset.link;
      }

      if (url) {
        location.href = url;
      }
    });
  };

  bindSelectRedirect('filter-make');
  bindSelectRedirect('filter-model');
});

if (window.catalogTemplate === 'lots-3') {
  document.addEventListener('DOMContentLoaded', function () {
    if ('undefined' !== typeof FWP) {
      FWP.auto_refresh = false;
    }
  });
  let flagFacetMakeSelectAddListener = false;
  document.addEventListener('facetwp-loaded', function () {
    if (!flagFacetMakeSelectAddListener) {
      flagFacetMakeSelectAddListener = true;
      const facetMakeSelect = document.querySelector(
        '.facetwp-facet-make select',
      );
      // @ts-expect-error - ts doesn't know about fselect
      facetMakeSelect?.fselect.on(
        'change',
        '.facetwp-facet-make select',
        function () {
          FWP.refresh();
        },
      );
    }
  });
}

// Keep the address bar in step with FacetWP's pager.
//
// FacetWP writes pagination only into the query string (`?_paged=N`) and
// never touches the path, so `setHash()` leaves a stale `/page/N/` segment
// behind after a client-side page switch — click page 1 from
// `/catalog/page/19/` and the URL still reads `page/19/`, so the next
// reload throws the visitor back to page 19. Rebuild both halves of the URL
// after every load to match the server's pretty form
// (inc/wp-facet.php :: w8_set_paged_path): `/page/N/` in the path when
// N > 1, and no leftover `_paged` query var.
document.addEventListener('facetwp-loaded', function () {
  // `FWP.settings.pager.page` is refreshed from the server response on every
  // render, so it is the authoritative current page here — unlike `FWP.paged`,
  // which `FWP.refresh()` resets back to 1 before this event fires.
  const page = Number(FWP.settings?.pager?.page) || 1;

  const url = new URL(window.location.href);
  url.pathname =
    url.pathname.replace(/\/page\/\d+(?=\/|$)/, '').replace(/\/?$/, '/') +
    (page > 1 ? `page/${page}/` : '');
  url.searchParams.delete('_paged');

  const next = url.pathname + url.search + url.hash;
  if (
    next !==
    window.location.pathname + window.location.search + window.location.hash
  ) {
    window.history.replaceState(null, '', next);
  }
});

// Keep the H1 in step with the page too. `get_lots_context()` / the
// `page-info` block (inc/acf.php) bake " - Page N" into `fields.ttl`
// server-side, once, at render time — nothing re-renders that markup on a
// client-side FacetWP refresh (it lives outside `.facetwp-template`), so
// reloading on /page/30/ and then paginating back to page 1 via AJAX left
// "- Страница 30" stuck in the heading. Resync it here from the same
// authoritative `FWP.settings.pager.page` the URL fix above uses, using the
// localized "Page" label exposed via `theme.translations.page_label`
// (src/Site.php) so this doesn't have to guess the site's locale.
document.addEventListener('facetwp-loaded', function () {
  const pageLabel = window.theme.translations.page_label;
  const h1 = document.querySelector('h1');
  if (!h1 || !pageLabel) return;

  // The suffix is always appended as plain text after whatever markup
  // fields.ttl carries (bold brand names, etc. — W8-3232), so patch
  // innerHTML rather than textContent: textContent would read back (and
  // write back) the heading as one flattened string and silently drop all
  // of that inline formatting.
  const page = Number(FWP.settings?.pager?.page) || 1;
  const escapedLabel = pageLabel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // WordPress's wptexturize() turns the plain " - " that inc/acf.php
  // concatenates into an en dash ("–") by the time it reaches the DOM, so
  // matching only "-" never found the existing suffix and kept stacking a
  // second one on every refresh (W8-3232). Accept any dash-like character
  // and reuse whichever one was actually there instead of guessing.
  const suffixPattern = new RegExp(
    `\\s*([-\\u2010-\\u2015])\\s*${escapedLabel}\\s*\\d+\\s*$`,
  );
  const match = h1.innerHTML.match(suffixPattern);
  const base = match ? h1.innerHTML.slice(0, match.index) : h1.innerHTML;
  const dash = match ? match[1] : '-';
  h1.innerHTML = page > 1 ? `${base} ${dash} ${pageLabel} ${page}` : base;
});

// Browser Back/Forward doesn't restore which page was showing. FacetWP's own
// `popstate` handler (facetwp/assets/js/src/front.js bindEvents()) calls
// refresh() without re-reading the URL — `loadFromHash()`, the method that
// knows how to pull `_paged` back out of the query string, only ever runs on
// the very first page load (`if (!FWP.loaded)`). Every refresh() also resets
// `FWP.paged` to 1 as a "cleanup" step, so by the time a popstate fires,
// FWP.paged is always 1 and FacetWP fetches page 1 no matter which page the
// address bar just navigated back to. `facetwp-refresh` fires synchronously
// inside refresh(), before it reads FWP.paged into the AJAX payload, so
// fixing it up here — from the URL FacetWP itself just navigated to — lands
// in time.
document.addEventListener('facetwp-refresh', function () {
  if (!FWP.is_popstate) return;

  const pathMatch = window.location.pathname.match(/\/page\/(\d+)(?:\/|$)/);
  const queryPaged = new URLSearchParams(window.location.search).get('_paged');
  FWP.paged = Number(queryPaged) || (pathMatch ? Number(pathMatch[1]) : 1);
  // Do not scroll on Back/Forward — keep the history entry's position
  // (pager/footer if that's where the user left). Pager clicks still
  // scroll via scrollToResultsAfterLoad.
});

document.addEventListener('facetwp-loaded', function () {
  const facets = document.querySelectorAll('.facetwp-facet');
  for (let i = 0; i < facets.length; i++) {
    const facet = facets[i];
    const facet_name = facet.getAttribute('data-name');
    if (facet_name == 'buy_it_now' && facet.firstChild) {
      facet.firstChild.classList.add('flex', 'items-center');
      const counter = facet.querySelector('.facetwp-counter');
      if (counter) {
        counter.innerHTML = `
					<svg class="fill-brand-base flex-none" width="26" height="26">
					  <use xlink:href="${theme.site.sprite.auto}#icon-buy-now"></use>
					</svg>
				`;
      }
    }
  }
});
